module.exports = __webpack_public_path__ + "static/media/result-consumer.18c06274.jpg";